export const unitRoleOptions = [
  'member',
  'resident',
  'tenant',
  'relative',
  'propertymanager',
  'customer-rep',
  'other',
]
